import { FileText, Loader2, Trash2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import {
  Attachment,
  AttachmentActions,
  AttachmentContent,
  AttachmentDescription,
  AttachmentMedia,
  AttachmentTitle,
} from '@/components/ui/attachment'

type ProductComplianceEvidenceListItemProps = {
  file: {
    fileName: string
    contentType: string | null
    fileSizeKb: number | null
    uploadedAt: string
  }
  isUploading?: boolean
  deleteDisabled?: boolean
  onDelete: () => Promise<unknown>
}

export function ProductComplianceEvidenceListItem({
  file,
  isUploading = false,
  deleteDisabled = false,
  onDelete,
}: ProductComplianceEvidenceListItemProps) {
  const { t } = useTranslation('common')

  return (
    <Attachment state={isUploading ? 'uploading' : 'done'} size='sm' className='w-full'>
      <AttachmentMedia>
        {isUploading ? (
          <Loader2 className='animate-spin' aria-hidden />
        ) : (
          <FileText aria-hidden />
        )}
      </AttachmentMedia>
      <AttachmentContent>
        <AttachmentTitle title={file.fileName}>{file.fileName}</AttachmentTitle>
        <AttachmentDescription>
          {file.fileSizeKb != null
            ? t('v2.pages.products.detail.drawings.fileSizeKb', {
                size: file.fileSizeKb,
              })
            : null}
        </AttachmentDescription>
      </AttachmentContent>
      <AttachmentActions>
        <Button
          type='button'
          variant='ghost'
          size='icon'
          disabled={deleteDisabled || isUploading}
          aria-label={t('v2.pages.products.detail.drawings.actions.delete')}
          onClick={() => {
            void onDelete()
          }}
        >
          <Trash2 className='size-4' />
        </Button>
      </AttachmentActions>
    </Attachment>
  )
}
